module.exports = __webpack_public_path__ + "static/media/icon_benefit_watch.20244faf.svg";